<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <card title="Influencer : " :value="this.influ_name">
        
        </card>
      </div>
    </div>
    <div class=" row">
      <div class="col-4">
        <card
          title="Total Members"
          :value="total_members"
        ></card>
      </div>
      <div class="col-4">
        <card
          title="Total Points"
          :value="total_points"
        ></card>
      </div>
      <div class="col-4">
        <card
          title="Total Exchange"
          :value="total_exchange + '.00'"
        ></card>
      </div>
        <!-- <card
          title="TEST"
          value="10"
          percentage="10"
          iconClass="ni ni-money-coinss"
          iconBackground="bg-gradient-primary"
          detail="Detail naja"
          directionReverse
        ></card> -->

    </div>
    <div class=" row">
      <div class="col-12">
        <referrers-table />
      </div>
    </div>
  </div>
</template>



<script>
/* eslint-disable */
// import AuthorsTable from "./components/AuthorsTable.vue";
import ReferrersTable from "./components/ReferrersTable.vue";
import Card from "@/examples/Cards/Card.vue";

export default {
  name: "referral",
  components: {
    ReferrersTable,
    Card,
  },
  data() {
    return {
      influencer_id : "",
      influ_name : "",
      total_members : 0,
      total_points : 0,
      total_exchange : 0,
      members : [],

    };
  },
  mounted () {
    var user = window.localStorage.getItem('$logged_user');
    // console.log("PARM")
    // console.log(this.$route.params)
    this.influ_name = this.$route.params.line_display
    this.total_members = this.$route.params.total_members
    this.total_points = this.$route.params.total_points
    this.members = this.$route.params.members
    // console.log(this.$route.params.members[0])

    if (user != 'admin')
      this.$router.push('/')
  }
};
</script>
